import { useMutation, useQueryClient } from "@tanstack/react-query";
import uuid from "uuid-random";
import { Crop, DropSize, Task, TillingDepth } from "./constants";
import { karlFarmPost } from "./queryClient";
import { getUseAllTasksQueryKey } from "./useAllTasks";

// Route: POST /data/tasks
// API Docs: https://documenter.getpostman.com/view/16381164/UVksNF2z#d1f770e1-93e0-4f64-88f2-9ec67d6d9a67

const addTaskPath = "/data/tasks";

export type AddTaskRequestBody = {
  id: string;
  attributes: {
    title: string;
    task: Task;
    crop?: Crop;
    tilling_depth?: TillingDepth;
    drop_size?: DropSize;
    notes: string;
  };
  time: {
    /** UNIX epoch in seconds */
    start: number;
    /** In minutes */
    duration: number;
    /** UNIX epoch in seconds */
    earliest?: number;
    /** UNIX epoch in seconds */
    deadline?: number;
  };
  fields: Array<{ id: string }>;
  users: Array<{ id: string }>;
  machines: Array<{ id: string }>;
};

export const useAddTaskMutation = () => {
  const queryClient = useQueryClient();
  const tasksQueryKey = getUseAllTasksQueryKey();

  return useMutation(
    (body: Omit<AddTaskRequestBody, "id">) =>
      karlFarmPost(addTaskPath, {
        id: uuid(),
        ...body,
      }),
    {
      onSettled: () => {
        queryClient.invalidateQueries(tasksQueryKey);
      },
      onError: (error) => {
        console.error(error);
      },
    }
  );
};
